/* ==========================================================================
   Chippy — theme behaviour
   No dependencies. Every widget is opt-in via a data-attribute, so a section
   that isn't on the page simply never initialises.
   ========================================================================== */
(function () {
  'use strict';

  var money = function (cents, suffix) {
    var n = (cents / 100);
    var s = n.toLocaleString('da-DK', {
      minimumFractionDigits: n % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2
    });
    return s + (suffix == null ? ' kr' : suffix);
  };

  var num = function (v) { return parseInt(v, 10) || 0; };

  /* Bevægelse er en anmodning, ikke en ret: har brugeren slået den fra i
     systemet, kører intet af det nedenfor, og siden står stille og synlig. */
  var motionOK = function () {
    return !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  };

  /* Genstarter animationen ved at fjerne klassen, tvinge et layout-opslag og
     sætte den på igen — ellers ignorerer browseren en klasse der allerede sad. */
  function bump(el) {
    if (!motionOK()) return;
    el.classList.remove('is-bumped');
    void el.offsetWidth;
    el.classList.add('is-bumped');
  }

  /* Gavetrin skrives som «10:1, 25:3» — antal kort : gratis kort. Trin uden to
     rigtige tal kasseres i stilhed, så en tastefejl i temaeditoren aldrig kan
     love kunden et gratis kort butikken ikke har regnet med. */
  function parseGifts(spec) {
    if (!spec) return [];
    return spec.split(',').map(function (part) {
      var bits = part.split(':');
      return { at: num(bits[0]), n: num(bits[1]) };
    }).filter(function (g) {
      return g.at > 0 && g.n > 0;
    }).sort(function (a, b) { return a.at - b.at; });
  }

  /* --- Buy box ----------------------------------------------------------- */
  function initBuyBox(root) {
    var data = JSON.parse(root.querySelector('[data-buy-data]').textContent);
    var variants = data.variants;
    var moneyFormat = data.currencySuffix;
    var freeShipping = data.freeShippingThreshold; // cents, -1 = disabled
    var shippingCost = data.shippingCost;          // cents
    var basePrice = data.basePricePerCard;         // cents, single-card price

    var progRoot = root.querySelector('[data-progress]');
    var progFill = root.querySelector('[data-progress-fill]');
    var progLabel = root.querySelector('[data-progress-label]');
    var progSteps = Array.prototype.slice.call(root.querySelectorAll('[data-progress-step]'));
    var gifts = parseGifts(data.giftEnabled ? data.giftTiers : '');
    var wasWon = null;

    var idField = root.querySelector('[data-variant-id]');
    var qtyField = root.querySelector('[data-qty-input]');
    var tiers = Array.prototype.slice.call(root.querySelectorAll('[data-tier]'));
    var submit = root.querySelector('[data-submit]');

    var current = variants.filter(function (v) { return v.id === num(idField.value); })[0] || variants[0];

    /* --- Fold ud / fold sammen ------------------------------------------
       Liquid har allerede sat `hidden` på de felter der ikke er standard, og
       ladet det valgte blive stående. Her huskes den oprindelige tilstand, så
       «Vis færre» kan lægge den tilbage — og så det VALGTE felt altid bliver
       stående. Uden det kunne kunden vælge 500 stk., folde sammen igen og stå
       med en total på 16.000 kr uden ét eneste markeret felt at forklare den. */
    var tiersWrap = root.querySelector('.tiers');
    var moreBtn = root.querySelector('[data-tiers-more]');
    var moreLabel = root.querySelector('[data-tiers-more-label]');
    var tiersExpanded = false;
    var defaultHidden = tiers.filter(function (t) { return t.hasAttribute('hidden'); });

    function syncTiers() {
      if (!tiersWrap) return;
      defaultHidden.forEach(function (t) {
        var isCurrent = num(t.getAttribute('data-tier')) === current.id;
        if (tiersExpanded || isCurrent) t.removeAttribute('hidden');
        else t.setAttribute('hidden', '');
      });
      /* Præcis tre synlige felter → én række, også under 380 px. */
      var shown = tiers.filter(function (t) { return !t.hasAttribute('hidden'); }).length;
      tiersWrap.classList.toggle('is-trio', shown === 3);

      if (moreBtn) {
        moreBtn.hidden = defaultHidden.length === 0;
        if (moreLabel) {
          moreLabel.textContent = tiersExpanded
            ? (data.showFewerLabel || 'Vis færre')
            : (data.showAllLabel || 'Se alle antal');
        }
        moreBtn.setAttribute('aria-expanded', tiersExpanded ? 'true' : 'false');
      }
    }

    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        tiersExpanded = !tiersExpanded;
        syncTiers();
      });
    }

    function packs() { return Math.max(1, Math.min(99, num(qtyField.value) || 1)); }

    function render() {
      var p = packs();
      var cards = current.packSize * p;
      var subtotal = current.price * p;
      var shipping = (freeShipping >= 0 && subtotal >= freeShipping) ? 0 : shippingCost;
      var singleTotal = basePrice > 0 ? basePrice * cards : 0;
      var unit = current.packSize > 0 ? Math.round(current.price / current.packSize) : current.price;
      var cheaperPerCard = basePrice > 0 && singleTotal > subtotal;

      tiers.forEach(function (t) {
        var on = num(t.getAttribute('data-tier')) === current.id;
        t.setAttribute('aria-checked', on ? 'true' : 'false');
      });

      set('[data-out-packline]', current.packSize + ' ' + (data.unitWord || 'kort') + ' pr. pakke · ' + money(unit, moneyFormat) + ' pr. ' + (data.unitWord || 'kort'));
      /* NB: variablen `unit` er stykprisen i den her funktion. Enhedsordet SKAL
         hedde noget andet — en `var unit` her overskrev prisen med en streng,
         og besparelseslinjen skrev «NaN kr pr. kort» på kortsiden. */
      set('[data-out-cardcount]', cards.toLocaleString('da-DK') + ' ' + (data.unitWord || 'kort'));
      set('[data-out-subtotal]', money(subtotal, moneyFormat));
      set('[data-out-shipping]', shipping === 0 ? data.freeLabel : money(shipping, moneyFormat));
      set('[data-out-total]', money(subtotal + shipping, moneyFormat));
      /* Fragten som underlinje på totalen — ikke som sin egen række ovenover. */
      set('[data-out-totalsub]', shipping === 0
        ? (data.freeShipLabel || 'fri fragt')
        : (data.inclShipLabel || 'inkl. {{ amount }} fragt').replace('{{ amount }}', money(shipping, moneyFormat)));

      // Prissammenligning — to priser butikken faktisk tager, ikke en førpris.
      // "singleTotal" er hvad de samme kort ville koste købt ét ad gangen,
      // regnet ud fra enkeltkort-variantens egen pris. Ingen procenter, ingen
      // overstregning, intet compare_at_price.
      var compareEl = root.querySelector('[data-saving]');
      if (compareEl) {
        var saved = Math.max(0, singleTotal - subtotal);
        var pct = singleTotal > 0 ? Math.round((saved / singleTotal) * 100) : 0;
        var fill = function (s) {
          return s.replace('{{ unit }}', money(unit, moneyFormat))
                  .replace('{{ cards }}', cards.toLocaleString('da-DK'))
                  .replace('{{ saving }}', money(saved, moneyFormat))
                  .replace('{{ pct }}', pct)
                  .replace('{{ amount }}', money(singleTotal, moneyFormat));
        };
        /* Grøn KUN når der faktisk spares noget. Et grønt felt ved ét kort
           ville kvittere for en besparelse der ikke findes. */
        compareEl.classList.toggle('is-saving', cheaperPerCard);
        /* Ved ét kort er der intet at spare. Så skjules linjen helt i stedet
           for at stå og forklare en rabat kunden ikke har fået. */
        compareEl.hidden = !cheaperPerCard;
        var pctEl = root.querySelector('[data-out-savingpct]');
        if (pctEl) {
          pctEl.hidden = !(cheaperPerCard && pct > 0);
          if (!pctEl.hidden) pctEl.textContent = fill(data.comparePct || '');
        }
        if (cheaperPerCard) {
          set('[data-out-savinglabel]', fill(data.compareLabel));
          set('[data-out-savingnote]', fill(data.compareNote));
        } else {
          set('[data-out-savinglabel]', fill(data.compareLabelSingle));
          set('[data-out-savingnote]', fill(data.compareNoteSingle));
        }
      }

      if (submit) {
        submit.disabled = !current.available;
        var label = submit.querySelector('[data-submit-label]');
        if (label) label.textContent = current.available ? data.addLabel : data.soldOutLabel;
      }

      syncTiers();
      renderProgress(cards, subtotal);

      qtyField.value = p;
      idField.value = current.id;
      root.dispatchEvent(new CustomEvent('chippy:variant', { detail: current, bubbles: true }));
    }

    /* Fremdrift mod ét mål ad gangen.
       Fri fragt måles i kroner, gratis kort i antal kort — to enheder på samme
       linje ville være volapyk. Derfor peger baren altid på det NÆRMESTE mål
       kunden ikke har nået endnu, målt som andel af netop dét mål. Er alle mål
       nået, står den fuld og skifter farve; det er kvitteringen, og den falder
       på samme øjeblik som tallet ændrer sig. */
    function renderProgress(cards, subtotal) {
      if (!progRoot || !progFill || !progLabel) return;

      var goals = [];
      if (freeShipping > 0) {
        goals.push({ kind: 'ship', have: subtotal, need: freeShipping });
      }
      gifts.forEach(function (g) {
        goals.push({ kind: 'gift', have: cards, need: g.at, n: g.n });
      });

      if (!goals.length) { progRoot.hidden = true; return; }
      progRoot.hidden = false;

      var open = goals.filter(function (g) { return g.have < g.need; });
      var complete = open.length === 0;
      var pct, label;

      /* Belønningsrækken tændes trin for trin. Rækken står der hele tiden — også
         de trin kunden ikke har nået — for det er dét der trækker: man kan se
         hvad der ligger længere oppe. */
      var wonGift = gifts.filter(function (g) { return cards >= g.at; }).pop();
      var wonCount = 0;

      progSteps.forEach(function (step) {
        var need = num(step.getAttribute('data-need'));
        var isWon = step.getAttribute('data-kind') === 'ship'
          ? (freeShipping > 0 && subtotal >= need * 100)
          : cards >= need;
        if (isWon) wonCount++;
        if (step.classList.contains('is-won') !== isWon) {
          step.classList.toggle('is-won', isWon);
          if (isWon && wasWon !== null) bump(step);
        }
      });

      if (complete) {
        pct = 100;
        if (wonGift && freeShipping > 0) {
          label = data.progAllDone.replace('{{ gift }}', wonGift.n);
        } else if (wonGift) {
          label = data.progGiftWon.replace('{{ gift }}', wonGift.n);
        } else {
          label = data.progShippingDone;
        }
      } else {
        // Nærmeste mål = det med den største andel opnået.
        var next = open.reduce(function (a, b) {
          return (a.have / a.need) >= (b.have / b.need) ? a : b;
        });
        pct = Math.max(2, Math.min(99, (next.have / next.need) * 100));
        label = next.kind === 'ship'
          ? data.progShipping.replace('{{ amount }}', money(next.need - next.have, moneyFormat))
          : data.progGift.replace('{{ cards }}', next.need - next.have).replace('{{ gift }}', next.n);
      }

      /* Bredde frem for scaleX: fyldets runde højreende ville blive klemt flad
         af en skalering, og det er præcis den ende kunden ser bevæge sig.
         CSS'en ejer varigheden og kurven — her sættes kun måltallet. */
      progFill.style.width = pct + '%';
      progRoot.classList.toggle('is-complete', complete);
      progRoot.classList.toggle('is-won', wonCount > 0);

      /* Etiketten krydsfader i stedet for at skifte i ét ryk. Uden det skiftede
         teksten øjeblikkeligt, mens bjælken stadig gled — to forskellige
         tempi i samme lille komponent, og det var dét der læste som et hop.
         Skifter teksten ikke, sker der ingenting: ingen blink ved hvert klik. */
      if (progLabel.textContent !== label) {
        if (motionOK()) {
          progLabel.classList.add('is-swap');
          window.setTimeout(function () {
            progLabel.textContent = label;
            progLabel.classList.remove('is-swap');
          }, 200);
        } else {
          progLabel.textContent = label;
        }
      }

      /* Første render tæller ikke som en gevinst: der har kunden ikke gjort
         noget endnu, og en animation uden årsag er bare støj. */
      wasWon = wonCount;
    }

    function set(sel, text) {
      var el = root.querySelector(sel);
      if (!el || el.textContent === text) return;
      // Første render kvitterer ikke — der er ikke sket noget for kunden endnu.
      var changed = el.textContent !== '';
      el.textContent = text;
      if (changed && el.hasAttribute('data-bump')) bump(el);
    }

    tiers.forEach(function (t) {
      t.addEventListener('click', function () {
        if (t.disabled) return;
        var next = variants.filter(function (v) { return v.id === num(t.getAttribute('data-tier')); })[0];
        if (!next) return;
        current = next;
        render();
        if (history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', current.id);
          history.replaceState({}, '', url.toString());
        }
      });
    });

    root.addEventListener('click', function (e) {
      var step = e.target.closest('[data-step]');
      if (!step) return;
      qtyField.value = Math.max(1, Math.min(99, packs() + num(step.getAttribute('data-step'))));
      render();
    });

    qtyField.addEventListener('change', render);
    qtyField.addEventListener('input', render);

    render();
  }

  /* --- Avance-regner ------------------------------------------------------ */
  /* 🔴 Regnestykket må aldrig blive til en indtjeningspåstand. Den viser
     FORSKELLEN pr. kort mellem forhandlerens egen udsalgspris og hans
     indkøbspris — ikke en fortjeneste, og aldrig et beløb ganget op på antal
     kort. Se kommentaren i sections/forhandler-avance.liquid og STORE-SPEC §1. */
  function initMargin(root) {
    var data = JSON.parse(root.querySelector('[data-margin-data]').textContent);
    var packSel = root.querySelector('[data-margin-pack]');
    var priceIn = root.querySelector('[data-margin-price]');
    var suffix = data.currency;

    function render() {
      var pack = data.packs[num(packSel.value)] || data.packs[0];
      var cost = pack.unit;                                  // øre
      var sell = Math.max(0, num(priceIn.value)) * 100;      // kroner → øre
      var top = Math.max(cost, sell, 1);

      set('[data-margin-cost]', money(cost, suffix));
      set('[data-margin-sell]', money(sell, suffix));

      var costBar = root.querySelector('[data-margin-costbar]');
      var sellBar = root.querySelector('[data-margin-sellbar]');
      if (costBar) costBar.style.transform = 'scaleX(' + (cost / top) + ')';
      if (sellBar) sellBar.style.transform = 'scaleX(' + (sell / top) + ')';

      /* Sælger han under sin egen indkøbspris, siger vi det rent ud i stedet
         for at vise et negativt tal han skal tolke selv. */
      var diff = sell - cost;
      var label = root.querySelector('[data-margin-difflabel]');
      if (label) label.textContent = diff < 0 ? data.belowLabel : data.diffLabel;
      set('[data-margin-diff]', diff < 0 ? '—' : money(diff, suffix));
      root.classList.toggle('is-below', diff < 0);
    }

    function set(sel, text) {
      var el = root.querySelector(sel);
      if (el) el.textContent = text;
    }

    packSel.addEventListener('change', render);
    priceIn.addEventListener('input', render);
    priceIn.addEventListener('change', render);
    render();
  }

  /* --- Gallery + lightbox ------------------------------------------------- */
  function initGallery(root) {
    var main = root.querySelector('[data-gallery-main]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-thumb]'));
    var box = root.querySelector('[data-lightbox]');
    var boxImg = box && box.querySelector('[data-lightbox-img]');
    var count = box && box.querySelector('[data-lightbox-count]');
    var shots = box ? JSON.parse(box.querySelector('[data-lightbox-data]').textContent) : [];
    var at = 0;
    var lastFocus = null;

    root.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-gallery-thumb]');
      if (thumb && main) {
        /* srcset slår src. Skiftes kun `src`, vælger browseren stadig en
           kandidat fra det gamle srcset, og billedet står uændret — det er
           præcis den fejl miniaturerne havde. Derfor sættes srcset FØRST,
           og ryddes hvis miniaturen ikke har et. */
        var srcset = thumb.getAttribute('data-srcset');
        if (srcset) main.setAttribute('srcset', srcset);
        else main.removeAttribute('srcset');
        main.src = thumb.getAttribute('data-full');
        main.alt = thumb.getAttribute('data-alt') || '';
        thumbs.forEach(function (t) {
          t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
        });
        return;
      }
      if (e.target.closest('[data-gallery-open]')) open(currentIndex());
    });

    /* Lightboxen åbner på DET billede kunden kigger på — ikke altid på det
       første. Ellers hopper motivet under fingeren i det øjeblik den åbner. */
    function currentIndex() {
      var on = thumbs.filter(function (t) { return t.getAttribute('aria-current') === 'true'; })[0];
      var i = thumbs.indexOf(on);
      return i < 0 ? 0 : i;
    }

    function show(i) {
      if (!shots.length) return;
      at = (i + shots.length) % shots.length;   // bladring går rundt
      boxImg.src = shots[at].src;
      boxImg.alt = shots[at].alt || '';
      if (count) count.textContent = (at + 1) + ' / ' + shots.length;
    }

    function open(i) {
      if (!box) return;
      lastFocus = document.activeElement;
      show(i);
      box.hidden = false;
      // Baggrunden må ikke kunne scrolles under overlayet.
      document.documentElement.style.overflow = 'hidden';
      var close = box.querySelector('[data-lightbox-close]');
      if (close && close.focus) close.focus();
    }

    function close() {
      if (!box || box.hidden) return;
      box.hidden = true;
      document.documentElement.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    if (box) {
      box.addEventListener('click', function (e) {
        if (e.target.closest('[data-lightbox-close]')) return close();
        if (e.target.closest('[data-lightbox-next]')) return show(at + 1);
        if (e.target.closest('[data-lightbox-prev]')) return show(at - 1);
      });
      document.addEventListener('keydown', function (e) {
        if (box.hidden) return;
        if (e.key === 'Escape') close();
        else if (e.key === 'ArrowRight') show(at + 1);
        else if (e.key === 'ArrowLeft') show(at - 1);
      });
    }
  }

  /* --- FAQ accordion ----------------------------------------------------- */
  /* Markup'et lander med `hidden` på de lukkede svar, så siden ikke blinker med
     alt åbent inden JS kører. Her byttes attributten til en klasse, som kan
     animeres — tilstanden er nøjagtig den samme, kun foldet ud over 0,3 sek. */
  function initFaq(root) {
    root.querySelectorAll('[data-faq-q]').forEach(function (q) {
      var panel = document.getElementById(q.getAttribute('aria-controls'));
      if (!panel || !panel.hidden) return;
      panel.hidden = false;
      panel.classList.add('is-collapsed');
    });

    root.addEventListener('click', function (e) {
      var q = e.target.closest('[data-faq-q]');
      if (!q) return;
      var open = q.getAttribute('aria-expanded') === 'true';
      var panel = document.getElementById(q.getAttribute('aria-controls'));
      q.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (panel) panel.classList.toggle('is-collapsed', open);
    });
  }

  /* --- Indtoning ved scroll ---------------------------------------------- */
  /* Hver gruppe deler forælder, så rækkefølgen i DOM'en bliver forsinkelsen på
     skærmen: to produktkort, tre trin, fire hero-linjer. Forsinkelsen er loftet
     ved fire trin — derover venter man på en side i stedet for at læse den. */
  var REVEAL = [
    { sel: '.hero__title, .hero .lede, .hero__proof, .hero__actions', stagger: 70 },
    { sel: '.section > .h2, .section > .sub, .section > .eyebrow', stagger: 60 },
    { sel: '.duo__card', stagger: 90 },
    { sel: '.step', stagger: 90 },
    { sel: '.strip, .duo__note, .steps__foot, .pchart, .ptable, .faq__list, .cta-dark, .grid > *', stagger: 60 },
    /* `.tal` observeres som ÉN blok, ikke som tre kort. Stagger står på 0,
       fordi forskydningen ligger i CSS'en (`--i` pr. kort) — så starter alle
       tre fra samme øjeblik og trapper op indefra. Observeres kortene enkeltvis
       i stedet, fyrer de efter hvor langt ned de tilfældigvis står, og på mobil
       hvor de er stablet, mister man hele trappen. */
    { sel: '.tal', stagger: 0 }
  ];

  function initReveal(scope) {
    if (!motionOK() || !('IntersectionObserver' in window)) return;
    document.documentElement.classList.add('js-motion');

    var delivered = 0;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        entry.target.classList.add('is-in');
        delivered++;
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.01 });

    /* Sikkerhedsnet. Indholdet ligger og venter på opacity 0, indtil observeren
       melder tilbage — og en observer der aldrig fyrer, ville efterlade en blank
       butik. Det sker fx når fanen åbnes i baggrunden: browseren sætter
       rendering på pause, og så leveres der ingenting. Er der ikke tonet ét
       eneste element ind efter tre sekunder, droppes effekten helt og alt vises.
       Hellere en side uden bevægelse end en side uden indhold. */
    setTimeout(function () {
      if (delivered > 0) return;
      document.querySelectorAll('[data-reveal]').forEach(function (el) {
        el.classList.add('is-in');
      });
    }, 3000);

    REVEAL.forEach(function (group) {
      var counts = new Map();
      (scope || document).querySelectorAll(group.sel).forEach(function (el) {
        if (el.hasAttribute('data-reveal')) return;
        var i = counts.get(el.parentElement) || 0;
        counts.set(el.parentElement, i + 1);
        el.setAttribute('data-reveal', '');
        if (i > 0) el.style.setProperty('--reveal-delay', Math.min(i, 4) * group.stagger + 'ms');
        io.observe(el);
      });
    });
  }

  /* --- Cart line removal / quantity -------------------------------------- */
  function initCart(root) {
    root.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-cart-remove]');
      if (!rm) return;
      e.preventDefault();
      var form = rm.closest('form');
      var input = form.querySelector('[data-cart-qty="' + rm.getAttribute('data-cart-remove') + '"]');
      if (input) { input.value = 0; form.submit(); }
    });
  }

  /* --- Sticky header ------------------------------------------------------ */
  /* Tegner kun stregen under headeren når man faktisk har scrollet, så den
     ikke ligger og deler siden op når man står øverst. */
  function initStickyHeader() {
    var header = document.querySelector('.site-header');
    if (!header) return;
    var ticking = false;
    function update() {
      header.classList.toggle('is-stuck', window.scrollY > 4);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  /* --- Mobilmenu ---------------------------------------------------------- */
  /* Panelet er ÉN menu i to former — de samme <a>'er som pillen på desktop.
     Uden JS sker der ingenting: knappen findes, men panelet har ingen
     `is-open`, og skyggen er `hidden`. Menuen er derfor aldrig en blindgyde,
     den er bare ikke foldbar. */
  function initNav() {
    var toggle = document.querySelector('[data-nav-toggle]');
    var panel = document.querySelector('[data-nav]');
    var scrim = document.querySelector('[data-nav-scrim]');
    if (!toggle || !panel) return;

    var lastFocus = null;

    /* Panelet hænger under headerens FAKTISKE underkant. Den flytter sig:
       toplinjen kan være slået fra, og headeren skifter højde når den sætter
       sig fast ved scroll. Derfor måles den hver gang menuen åbner. */
    function place() {
      var header = document.querySelector('.site-header');
      if (!header) return;
      var bottom = header.getBoundingClientRect().bottom;
      panel.style.top = Math.round(bottom + 8) + 'px';
      panel.style.maxHeight = 'calc(100vh - ' + Math.round(bottom + 24) + 'px)';
    }

    function isOpen() { return toggle.getAttribute('aria-expanded') === 'true'; }

    function open() {
      place();
      lastFocus = document.activeElement;
      panel.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      if (scrim) scrim.classList.add('is-open');
      // Baggrunden må ikke kunne scrolles bag panelet. Samme greb som
      // lightboxen bruger — på <html>, ikke på <body>: `overflow` på body
      // slår den klæbende header ihjel.
      document.documentElement.style.overflow = 'hidden';
      var first = panel.querySelector('a');
      if (first && first.focus) first.focus();
    }

    function close(refocus) {
      if (!isOpen()) return;
      panel.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      if (scrim) scrim.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      if (refocus && toggle.focus) toggle.focus();
    }

    toggle.addEventListener('click', function () {
      if (isOpen()) close(false); else open();
    });

    if (scrim) scrim.addEventListener('click', function () { close(true); });

    /* Et klik på et link lukker menuen. På en side der linker til sig selv
       (fx et anker) ville panelet ellers blive stående oven på indholdet. */
    panel.addEventListener('click', function (e) {
      if (e.target.closest('a')) close(false);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close(true);
    });

    /* Roterer telefonen, eller vokser vinduet forbi brudpunktet, skal panelet
       enten flytte med eller forsvinde helt — ellers står det og svæver som en
       hvid kasse midt på en desktop-side. */
    window.addEventListener('resize', function () {
      if (!isOpen()) return;
      if (window.innerWidth > 1210) {
        close(false);
        panel.style.top = '';
        panel.style.maxHeight = '';
      } else {
        place();
      }
    });
  }

  /* --- Farvevalg styrer galleriet ----------------------------------------- */
  /* Vælger kunden «Kun sort», skal billedet vise et sort kort. Uden det er
     valget ord uden dækning, og man kan ikke se hvad man har valgt.

     Vi KLIKKER på miniaturen i stedet for at sætte src selv — så ligger
     billedskiftet stadig ét sted (initGallery), inkl. srcset og aria-current.
     Matcher intet, sker der ingenting: et manglende billede må aldrig
     forhindre kunden i at vælge farve. */
  /* 🔴 `[data-gallery]` og `[data-buy-box]` er SØSKENDE i buy-box.liquid, ikke
     indlejrede. Scoper man til købsboksen, findes miniaturerne aldrig — og
     funktionen fejler lydløst. Derfor slås der op fra sektionens rod. */
  function initSwatchGallery(scope) {
    var el = scope || document;
    var swatches = el.querySelectorAll('.swatches input[type="radio"]');
    if (!swatches.length) return;
    var first = swatches[0];
    var section = first.closest('[id^="shopify-section"]') || el;
    var thumbs = Array.prototype.slice.call(section.querySelectorAll('[data-gallery-thumb]'));
    if (thumbs.length < 2) return;

    function pick(value) {
      var v = (value || '').toLowerCase();
      // «Blandet …» → første billede, som er de to kort side om side.
      if (v.indexOf('blandet') === 0) return thumbs[0];
      // Ellers: første miniature hvis alt-tekst BEGYNDER med farven.
      // Alt-teksterne starter med farven ("Sort …", "Hvidt …"), og «hvid»
      // matcher derfor også "Hvidt".
      var word = v.replace(/^kun\s+/, '').split(/\s+/)[0];
      if (!word) return null;
      for (var i = 0; i < thumbs.length; i++) {
        var alt = (thumbs[i].getAttribute('data-alt') || '').toLowerCase();
        if (alt.indexOf(word) === 0) return thumbs[i];
      }
      return null;
    }

    swatches.forEach(function (input) {
      input.addEventListener('change', function () {
        if (!input.checked) return;
        var t = pick(input.value);
        if (t) t.click();
      });
    });
  }

  /* --- Boot -------------------------------------------------------------- */
  var headerBooted = false;

  function boot(scope) {
    (scope || document).querySelectorAll('[data-buy-box]').forEach(initBuyBox);
    (scope || document).querySelectorAll('[data-gallery]').forEach(initGallery);
    initSwatchGallery(scope);
    (scope || document).querySelectorAll('[data-faq]').forEach(initFaq);
    (scope || document).querySelectorAll('[data-cart]').forEach(initCart);
    (scope || document).querySelectorAll('[data-margin]').forEach(initMargin);
    initReveal(scope);
    // Headeren findes én gang på siden — lytteren må ikke sættes på igen hver
    // gang temaeditoren genindlæser en sektion.
    if (!headerBooted) { headerBooted = true; initStickyHeader(); }
    // Headeren genindlæses som sin egen sektion i temaeditoren, og så er
    // knappen en ny node. Derfor bindes menuen op hver gang header-sektionen
    // kommer ind — men kun den, ikke resten.
    if (!scope || scope.querySelector('[data-nav-toggle]')) initNav();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  // Theme editor: re-init a section after it is re-rendered.
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
